import React from 'react';
import StatusIndicatorForPIWA from '../../../shared/openOrClosedIndicatorForWA/content';
import { SuspendMessageForManage, SuspendMessageForView } from './suspendMessage';

export default function ViewOneWaitingAreaCenterPanelShared(props) {
  const waitingArea = props.waitingArea;
  const hasManageWaitingAreaAccess =
    waitingArea &&
    waitingArea.permissions &&
    waitingArea.permissions.length > 0 &&
    waitingArea.permissions.indexOf('MANAGE_ACCESS') > -1;

  let suspendedMessage = '';
  let noCallsMessage = '';

  if (
    !props.fetchingWaitingArea &&
    props.waitingAreaRoomsFiltered.length == 0 &&
    props.waitingAreaRoomsGray.length == 0 &&
    !waitingArea.isSuspended &&
    !props.isForConsultNow // for consult now there is different way to check for calls in progress, handled in its own component
  ) {
    if (waitingArea.operatingHours && waitingArea.operatingHours.isOpen) {
      noCallsMessage = (
        <div className="row flexible row-hoverable center-text pointer">
          <div className="column text-size-ml">{APP.LANGUAGE.ViewOneWaitingArea.NoCallsInProgress}</div>
        </div>
      );
    }
  }

  if (hasManageWaitingAreaAccess && waitingArea.isSuspended) {
    suspendedMessage = <SuspendMessageForManage waitingArea={waitingArea} />;
  } else if (waitingArea.isSuspended) {
    suspendedMessage = <SuspendMessageForView waitingArea={waitingArea} />;
  }

  let openOrCloseMessage =
    waitingArea.operatingHours &&
    waitingArea.operatingHours.nextOpenTime &&
    waitingArea.operatingHours.nextClosedTime &&
    !waitingArea.isSuspended &&
    props.timezone != undefined &&
    !props.fetchingWaitingArea ? (
      <StatusIndicatorForPIWA
        waitingAreaClosingMessageThresholdMinutes={props.waitingAreaClosingMessageThresholdMinutes}
        timezone={props.timezone}
        waStatusObject={waitingArea.operatingHours}
        waitingAreaId={waitingArea.id}
        renderOption="piwa"
      />
    ) : (
      ''
    );

  let mainWAContent = (
    <React.Fragment>
      {suspendedMessage}
      {openOrCloseMessage}
      {noCallsMessage}
    </React.Fragment>
  );

  return mainWAContent;
}
